import React, { useEffect } from 'react'
import Layout from '../../components/layout/layout'
import { Container, Heading, Section } from 'react-bulma-components'
import { useHasNewChangelog } from '../../hooks/use-has-new-changelog'
import SupportEmail from '../../components/support-email/support-email'
//@ts-ignore
import changelog from '../../../changelog.md'

export const WhatsNewPage: React.FC = () => {
  const { dismiss } = useHasNewChangelog()

  useEffect(() => {
    dismiss()
  }, [dismiss])

  return (
    <Layout>
      <Section size="medium">
        <Container max={true} breakpoint={'desktop'}>
          <Heading textColor="primary" size={4}>
            Retours d'expérience, idées ou frustrations ?
          </Heading>
          Notre équipe répond toujours dans les plus brefs délais
          <br /> <br />
          <SupportEmail />
          <br />
          <hr />
          <br />
          <br />
          <div className="content" dangerouslySetInnerHTML={{ __html: changelog }} />
        </Container>
      </Section>
    </Layout>
  )
}
